import React, { Component } from 'react'
import { connect } from 'react-redux'
import { fetchTransactions, resetErrors, fetchSaldoFromInicio } from '../actions/transactionsActions'
import { fetchCompanies, selectCompany, uploadSettings} from '../actions/userActions'
import Table from './Table'
import Stats from './Stats'
import Filters from './Filters'
import Actions from './Actions'
import { Link } from 'react-router-dom'

@connect((store)=>{
  return {
    transactions: store.transactions.transactions,
    transactionsFetched: store.transactions.fetched,
    transactionsFetching: store.transactions.fetching,
    transactionsError: store.transactions.error,
    fetchRequest: store.transactions.fetchRequest,
    userCompanies: store.user.userCompanies,
    selectedCompany: store.user.selectedCompany,
    currentSettings: store.user.currentSettings,
    userId: store.user.userData.uid
  } 
})
class Transactions extends Component {

  componentWillMount(){
        this.props.dispatch(fetchCompanies(this.props.userId))
  }  
  
  componentWillUnmount() {
    this.props.dispatch(resetErrors())
  }

  // apply user filters before sending to child components
  filterTransactions(){
    if(this.props.currentSettings){
      return this.props.transactions.filter( x => {
        // get processado settings
        let processado;
        if(this.props.currentSettings.processado){
          if(this.props.currentSettings.processado.value === 'todos'){
            processado = x.processado
          } else {
            processado = this.props.currentSettings.processado.value === 'sim' ? true : false
          }
          
        }
        // perform search
        let string = x.descricao.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase()
        return string.search(this.props.currentSettings.search) > -1 &&
        // filter processado field
        (this.props.currentSettings.processado ? x.processado === processado : true) &&
        // filter contas field
        (this.props.currentSettings.conta.value ? x.conta === this.props.currentSettings.conta.value || this.props.currentSettings.conta.value === 'todas' : true) &&
        // filter tags field
        (this.props.currentSettings.tags.value ? x.tags.includes(this.props.currentSettings.tags.value) || this.props.currentSettings.tags.value === 'todas' : true)
    })
    } else{
      return this.props.transactions
    }

  }

  componentWillReceiveProps(nextProps) {
    if(this.props.currentSettings !== nextProps.currentSettings){
      this.props.dispatch(fetchTransactions(nextProps.selectedCompany, nextProps.currentSettings || {
        inicio: Date.now(),
        fim: Date.now(),
        conta: {value: 'todas', label:'Todas'},
        processado: {value: 'todos', label:'Todos'},
        search: "",
        tags: {value: 'todas', label:'Todas'},
      }))
      this.props.dispatch(uploadSettings(nextProps.userId, nextProps.selectedCompany, nextProps.currentSettings || {
        inicio: new Date(),
        fim: new Date(),
        conta: {value: 'todas', label:'Todas'},
        processado: {value: 'todos', label:'Todos'},
        search: "",
        tags: {value: 'todas', label:'Todas'},
      }))
      this.props.dispatch(fetchSaldoFromInicio(nextProps.selectedCompany, nextProps.currentSettings || {
        inicio: Date.now(),
        fim: Date.now(),
        conta: {value: 'todas', label:'Todas'},
        processado: {value: 'todos', label:'Todos'},
        search: "",
        tags: {value: 'todas', label:'Todas'},
      }))
    }
  }

  handleSubmit = (e) => {
    this.props.dispatch(selectCompany(e,this.props.userCompanies))
  }

  render() {

    if(this.props.transactionsFetching){
      return (<div className="loader">Loading...</div>)
    }

    if(this.props.userCompanies && !this.props.transactions){

      if (this.props.userCompanies.length === 1){
        this.handleSubmit(this.props.userCompanies[0].value)
      }

      let empresas = this.props.userCompanies.map((data, key) => {
        return <li key={key}><Link to="/transactions" onClick={(e) => this.handleSubmit(data.value)}>{data.label}</Link></li>
      })

      return (
      <div>
        <h6><i className="far fa-building" style={{color:"#33C3F0"}}/> Selecione Empresa</h6>
        <ul>{empresas}</ul>
      </div>)
    }

    if(this.props.transactions){
      
    return (
      <div>
          <Stats transactions={this.filterTransactions()} currentSettings={this.props.currentSettings} />
          <Filters transactions={this.props.transactions} selectedEmpresa={this.props.selectedCompany} />
          <Actions selectedCompany={this.props.selectedCompany} transactions={this.filterTransactions()}/>
          <Table transactions={this.filterTransactions()} currentSettings={this.props.currentSettings}/>
      </div>)

      }

    // if still waiting, run loader
    return (<div className="loader">Loading...</div>)

  }
}

export default Transactions;



// WEBPACK FOOTER //
// ./src/components/Transactions.js